import { createUseStyles } from 'react-jss';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 0,
        alignSelf: 'stretch',
        minHeight: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
    },

    headerWraper: {
        display: 'flex',
        height: 80,
        padding: '15px',
        alignItems: 'center',
        gap: '16px',
        alignSelf: 'stretch',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
        background: theme.colors.surface_page,
    },

    imageContainer:{
        display: 'flex',
        width: 32,
        height: 32,
        padding: '0 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        borderRadius: 4,

        '& img':{
            // marginRight: theme.spacing(2),
            width: 22,
            height: 22,

            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    executionDateContainer:{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: '12px',
        flex: '1 0 0',
        fontFamily: theme.font.secondary,
        color: theme.colors.black,

        '& b':{
            fontSize: '18px',
            fontStyle: 'normal',
        },
        '& p':{
            fontSize: '16px',
            fontStyle: 'normal',
        },
    },

    executionTitleWrapper:{
        display: 'flex',
        marginTop: '8px',
        padding: '4px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 8,
        alignSelf: 'stretch',

        '& b':{
            color: theme.colors.text_heading,
            alignSelf: 'stretch',
            fontFamily: theme.font.primary,
            fontSize: 21,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
        },
        '& p':{
            color: theme.colors.grey_text,
            alignSelf: 'stretch',
            fontFamily: theme.font.secondary,
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
        },

    },
    executionVersionSubtle: {
        margin: '-6px 0 0',
        paddingLeft: 2,
        color: theme.colors.text_muted_purple,
        fontFamily: theme.font.primary,
        fontSize: 9,
        fontWeight: 600,
        letterSpacing: 1.1,
    },
    executionModeChip: {
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 24,
        padding: '0 12px',
        borderRadius: 999,
        background: theme.colors.transp_violet,
        color: theme.colors.violet_primary,
        fontFamily: theme.font.secondary,
        fontSize: 14,
        fontWeight: '700',
    },

    executionStatusWrapper:{
        display: 'flex',
        padding: '4px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,
        alignSelf: 'stretch',
    },
    executionStatusContainer:{
        display: 'flex',
        height: 56,
        padding: '0 16px',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'stretch',

        borderRadius: 4,
        borderLeft: '4px solid',
        background: theme.colors.white,
    },
    executionStatusLabel:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,

        '& b':{
            color: theme.colors.text_heading,
            alignSelf: 'stretch',
            fontFamily: theme.font.secondary,
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
        },
        '& p':{
            color: theme.colors.grey_text,
            alignSelf: 'stretch',
            fontFamily: theme.font.secondary,
            fontSize: 12,
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
        },
    },

    userDataWrapper:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        gap: 0,
        paddingBottom: 0,
        borderBottom: '1px solid ${theme.colors.grey_light}',
    },
    userDataRow:{
        display: 'flex',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        borderTop: '1px solid ${theme.colors.grey_light}',

        '& b':{
            color: '${theme.colors.text_heading};',
            fontFamily: theme.font.secondary,
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: '700',
            lineHeight: 'normal',
        },
        '& p':{
            color: '${theme.colors.text_heading};',
            fontFamily: theme.font.secondary,
            fontSize: 16,
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: 'normal',
        },
    },
    userDataCellLeft:{
        display: 'flex',
        height: 64,
        padding: '16px 24px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 12,
        flex: '1 0 0',
        borderRight: '1px solid ${theme.colors.grey_light}',
    },
    userDataCellRight:{
        display: 'flex',
        height: 64,
        padding: '12px 24px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        gap: 12,
        flex: '1 0 0',
    },

    additionalDataSection: {
        display: 'flex',
        padding: '16px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 8,
        alignSelf: 'stretch',
    },
    additionalDataHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    additionalDataEyebrow: {
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 24,
        padding: '0 10px',
        borderRadius: 999,
        color: theme.colors.indigo_primary,
        background: 'rgba(95, 75, 139, 0.08)',
        border: '1px solid rgba(95, 75, 139, 0.14)',
        fontFamily: theme.font.secondary,
        fontSize: 10,
        fontWeight: 700,
        lineHeight: 1,
        letterSpacing: 0.9,
        textTransform: 'uppercase',
    },

    videoWrapper:{
        display: 'flex',
        padding: '16px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
        alignSelf: 'stretch',
        borderBottom: `1px solid rgba(95, 75, 139, 0.14)`,
    },
    videoHeader:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        alignSelf: 'stretch',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    videoHeaderLabel:{
        display: 'flex',
        alignItems: 'center',

        '& img': {
            marginRight: theme.spacing(2),
            height: 24,
            width: 24,
        },
    },
    videoContainer:{
        display: 'flex',
        height: '198px',
        alignItems: 'flex-end',
        gap: 8,
        alignSelf: 'stretch',
        borderRadius: 4,
        marginBottom: 5,
    },
    video:{
        width: '100%',
    },
    noMediaPresent:{
        height: '100%',
        width: '100%',
        alignContent: 'center',
        textAlign: 'center',
        fontFamily: theme.font.secondary,
        fontStyle: 'italic',
    },

    improvementWrapper:{
        display: 'flex',
        padding: '12px 24px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 16,
        alignSelf: 'stretch',
        borderBottom: `1px solid  rgba(95, 75, 139, 0.14)`,
    },
    improvementHeader:{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        alignSelf: 'stretch',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    improvementHeaderLabel:{
        display: 'flex',
        alignItems: 'center',

        '& img': {
            marginRight: theme.spacing(2),
            height: 24,
            width: 24,
        },
    },
    improvementsContainer:{
        height: '190px',
    },

    infoGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: 8,
        alignSelf: 'stretch',
    },
    infoCard: {
        display: 'flex',
        minHeight: 68,
        padding: '12px 12px 11px',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 6,
        overflow: 'hidden',
        border: `1px solid ${theme.colors.border_subtle}`,
        borderRadius: 10,
        background: theme.colors.surface_elevated,
        boxShadow: theme.isDark ? '0 2px 8px rgba(0,0,0,0.35)' : `0 8px 18px ${theme.colors.border_subtle}`,
    },
    infoLabel: {
        color: theme.colors.text_muted_purple,
        fontFamily: theme.font.secondary,
        fontSize: 10,
        fontWeight: 700,
        lineHeight: 1.2,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
    },
    infoValue: {
        color: theme.colors.text_heading,
        fontFamily: theme.font.secondary,
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 1.3,
        minWidth: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 2,
        wordBreak: 'break-word',
    },

    [theme.down('desktop')]: {
        executionTitleWrapper: {
            '& b': {
                fontSize: 19,
            },
            '& p': {
                fontSize: 14,
            },
        },
        infoGrid: {
            gridTemplateColumns: '1fr',
        },
        additionalDataSection: {
            padding: '0 20px',
        },
        infoCard: {
            minHeight: 64,
        },
    },
}));